import { Alert, Button, Form, InputGroup } from 'react-bootstrap';
import { CartContext } from './context/CartContext';
import CartDiscountCodeList from './CartDiscountCodeList';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import '../styles/CartDiscountCodes.css';


const CartDiscountCodes = () => {
    const {
        applyDiscountCode,
        cartState,
        cartUpdating,
        checkoutData,
    } = useContext(CartContext);
    const [discountCode, setDiscountCode] = useState('');
    const [feedback, setFeedback] = useState({});

    const isDisabled = useMemo(() => cartUpdating || !(
        cartState?.length > 0 && checkoutData.webUrl
    ), [cartState, checkoutData]);

    const handleDiscountCodeChange = useCallback((e) => setDiscountCode(e.target.value), [setDiscountCode]);

    const handleRemoveDiscountCodeFailure = useCallback((message) => setFeedback({
        type: 'danger',
        message,
    }), []);

    const handleRemoveDiscountCodeSuccess = useCallback(() => setFeedback({
        type: 'success',
        message: 'The discount code was successfully removed.'
    }), []);

    const handleFormSubmission = useCallback(async (e) => {
        try {
            e.preventDefault();
            const result = applyDiscountCode(discountCode);
            if (result.success === true) {
                setFeedback({
                    type: 'success',
                    message: <span>
                        Coupon code: <strong>{discountCode}</strong> has been added successfully.
                    </span>,
                });
                setDiscountCode('');
            } else {
                setFeedback({
                    type: 'danger',
                    message: result.error,
                });
            }
        } catch (e) {
            setFeedback({
                type: 'danger',
                message: e.message,
            });
        }
    }, [discountCode]);

    // Handle initial state.
    useEffect(() => {
        setFeedback({
            type: null,
            message: null,
        });
    }, []);

    return <>
        <Form
            onSubmit={handleFormSubmission}>
            <InputGroup>
                <Form.Control
                    className={'cart-discount-codes--input'}
                    disabled={isDisabled}
                    placeholder={'Enter Coupon Code'}
                    type={'text'}
                    value={discountCode}
                    onChange={handleDiscountCodeChange} />
                <Button
                    className={'cart-discount-codes--apply-button'}
                    disabled={isDisabled}
                    type={'submit'}>Apply</Button>
            </InputGroup>
            {feedback?.message && <Alert
                variant={feedback.type ?? 'info'}>
                {feedback.message}
            </Alert>}
        </Form>
        {checkoutData?.DiscountCodes?.length > 0 && <CartDiscountCodeList
            discountCodes={checkoutData.DiscountCodes}
            onRemoveDiscountCodeFailure={handleRemoveDiscountCodeFailure}
            onRemoveDiscountCodeSuccess={handleRemoveDiscountCodeSuccess}
        />}
    </>;
};

export default CartDiscountCodes;